import App from "./app/app";

const app = new App();
document.body.appendChild(app.pixiapp.view);
